import { Button } from '@hover/blueprint';
import { iChevronLeft } from '@hover/icons';
import React from 'react';

import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

export const BackButton = ({ onClick }: { onClick?: () => void }) => {
  const t = useTranslate(TranslationNamespace.SHARED);

  return (
    <Button
      display={{ base: 'none', tablet: 'flex' }}
      fill="minimal"
      iconBefore={iChevronLeft}
      onClick={onClick}
      size="large"
      sx={{ '& > div': { gap: '10px' } }}
    >
      {t('onboarding.back')}
    </Button>
  );
};
